import type { AppConfig } from 'types/app-config-types';
import { EnvironmentTypes } from 'types/app-config-types';

const oldBoVersion = '1.0.233';

const appConfig: AppConfig = {
  [EnvironmentTypes.PRODUCTION]: {
    legacyBackofficeUrl: `${window.location.origin}/paymentiq/bo/?version=${oldBoVersion}`,
    boApiEndpoint: window.location.origin,
    piqApiEndpoint: 'https://api.paymentiq.io',
    documentationUrl: 'https://docs.paymentiq.io',
    oldBoVersion,
    logoutUrl: `${window.location.origin}/paymentiq/logout`,
    aiqBoBaseUrl: 'https://backoffice.accountiq.io',
    aiqLandingPageUrl: 'https://home.accountiq.io',
    countlyAppKey: '44a5cdfd9cddb5d3d85c3d8f2e9ce4a1b291adbd',
    countlyUrl: 'https://countly.iqservices.io/',
    inkeepApiKey: 'f77f807ce081091873b4cda51546581046701f487afe1db0',
  },
  [EnvironmentTypes.TEST]: {
    legacyBackofficeUrl: `${window.location.origin}/paymentiq/bo/?version=${oldBoVersion}`,
    boApiEndpoint: window.location.origin,
    piqApiEndpoint: 'https://test-api.paymentiq.io',
    documentationUrl: 'https://test-docs.paymentiq.io',
    oldBoVersion,
    logoutUrl: `${window.location.origin}/paymentiq/logout`,
    aiqBoBaseUrl: 'https://backoffice.accountiq.io',
    aiqLandingPageUrl: 'https://home.accountiq.io',
    countlyAppKey: '2f7f09b12d35b6420873dae05a3e4a81efcd867a',
    countlyUrl: 'https://test-countly.iqservices.io',
    inkeepApiKey: '467c8245bc306465f82f69a5fddb9e4b97af728329f56740',
  },
  [EnvironmentTypes.DEV]: {
    legacyBackofficeUrl: `${window.location.origin}/paymentiq/bo/?version=${oldBoVersion}`,
    boApiEndpoint: window.location.origin,
    piqApiEndpoint: 'https://test-api.paymentiq.io',
    documentationUrl: 'https://test-docs.paymentiq.io',
    oldBoVersion,
    logoutUrl: `${window.location.origin}/paymentiq/logout`,
    aiqBoBaseUrl: 'https://backoffice.aiq-test.click',
    aiqLandingPageUrl: 'https://home.accountiq.io',
    countlyAppKey: '',
    countlyUrl: '',
    inkeepApiKey: '467c8245bc306465f82f69a5fddb9e4b97af728329f56740',
  },
};

export default appConfig;
